import { Radio, RadioGroup } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import React from "react";
import {
  isSingleSleeperSelector,
  primarySleeperBodyTypeSelector,
  secondarySleeperBodyTypeSelector,
  setPrimarySleeperBodyType,
  setSecondarySleeperBodyType,
} from "../../../../redux/slices/mattressConfiguration";
import { checkErrorsSelector } from "../../../../redux/slices/customNavigation";

const BodyTypeRadioButton = ({
  checked = false,
  label = "",
  index,
  editingSleeper1,
  bodyTypeValue
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const checkErrors = useSelector(checkErrorsSelector);

  const handleOnChange = () => {
    if (editingSleeper1 || isSingleSleeper) {
      dispatch(setPrimarySleeperBodyType(index));
    } else {
      dispatch(setSecondarySleeperBodyType(index));
    }
  };

  const errorColor = (bodyTypeValue === null && checkErrors) ? "red" : theme.COLORS.BLUE.darkBlueGreen;

  return (
    <div
      className="row radio-button-row"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        marginLeft: "20%",
        width: "auto"
      }}
    >
      <div className="col-auto flex justify-content-start align-items-center">
        <Radio
          checked={checked}
          size="small"
          onChange={handleOnChange}
          value="a"
          name="radio-buttons"
          inputProps={{ "aria-label": "A" }}
          sx={{ color: errorColor }}
        />
      </div>
      <div
        className="col-auto flex text-start"
        style={{
          fontFamily: "noto-sans",
          color: errorColor,
          padding: 0,
          fontSize: "0.9rem",
        }}
      >
        {label}
      </div>
    </div>
  );
};

const BodyTypeRadioGroup = ({ editingSleeper1 }) => {
  const radioButtonElements = [
    {
      label: "Muscled & toned",
    },
    {
      label: "Slim & lean",
    },
    {
      label: "Curvy & full-figured",
    },
  ];

  const isSingleSleeper = useSelector(isSingleSleeperSelector);
  const primarySleeperBodyType = useSelector(primarySleeperBodyTypeSelector);
  const secondarySleeperBodyType = useSelector(
    secondarySleeperBodyTypeSelector
  );

  const bodyTypeValue =
    editingSleeper1 || isSingleSleeper
      ? primarySleeperBodyType
      : secondarySleeperBodyType;

  // console.log("bodyTypeValue: " + bodyTypeValue);
  return (
    <div style={{ width: "100%" }}>
      <RadioGroup
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
      >
        {radioButtonElements.map((element, index) => {
          return (
            <BodyTypeRadioButton
              editingSleeper1={editingSleeper1}
              key={element.label}
              label={element.label}
              index={index}
              checked={index === bodyTypeValue}
              bodyTypeValue={bodyTypeValue}
            />
          );
        })}
      </RadioGroup>
    </div>
  );
};

export default BodyTypeRadioGroup;
